import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor(private loadingController: LoadingController) {}

  async showLoader() {
    const loading = await this.loadingController.create({
      message: 'Загрузка...',
      id: '0',
    });
    await loading.present();
  }

  completeLoader() {
    return this.loadingController.dismiss(null, null, '0');
  }
}
